import {takeEvery} from 'redux-saga/effects'
import {
  GET_EXAM_REMARKS_SHEET,
  SAVE_EXAM_REMARKS_SUBJECT,
  SAVE_EXAM_REMARKS_SUBSECTION,
} from 'setup/redux/Actions/ExamRemarks/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_EXAM_REMARKS_SHEET, fetchData)
  yield takeEvery(SAVE_EXAM_REMARKS_SUBJECT, fetchData)
  yield takeEvery(SAVE_EXAM_REMARKS_SUBSECTION, fetchData)
}

export default dataSaga
